/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const WebhookEgressTemplateOptions = core.serialization.object({
    namespace: core.serialization.string().optional(),
    jobName: core.serialization.string(),
    url: core.serialization.string(),
});
